<template>
  <div class="big kefu_doctor">
    <div class="page_title">客服绑定</div>
    <div style="padding: 20px">
      <div class="container">
        <div style="border: solid 1px #c9cbd6">
          <el-table
            ref="multipleTable"
            :data="tableData"
            tooltip-effect="dark"
            style="width: 100%; min-width: 1000px"
            :header-cell-style="{ background: '#F5F5F5' }"
            v-loading="loading"
            element-loading-text="拼命加载中"
            element-loading-background="rgba(0, 0, 0,0.1)"
          >
            <el-table-column label="坐席姓名" prop="name"> </el-table-column>

            <el-table-column
              prop="cno"
              label="坐席员工工号"
             
            ></el-table-column>
            <el-table-column
              
              label="绑定用户名"
            >
          <template slot-scope="scope">
              <div class="flex align-center">
                <div v-for="(item,index) in scope.row.admin_list" :key="index" style="margin-left:5px">
                  {{ item.admin_name }}
                </div>
              </div>
              </template>
          </el-table-column>
            <el-table-column
              prop="update_time"
              label="编辑时间"
            ></el-table-column>
          
            <el-table-column label="操作" width="320">
              <template slot-scope="scope">
                <el-button
                  @click="showDialog(scope.row)"
                  type="text"
                  :disabled="
                    module_id_array[0]
                      ? !module_id_array.includes('1617')
                      : false
                  "
                  >修改绑定</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div>
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="pagesize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalNum"
            style="margin-top: 20px"
          ></el-pagination>
        </div>
      </div>
    </div>
    <!-- 编辑标签 -->
    <el-dialog
      title="编辑客服标签"
      :visible.sync="dialogShow"
      width="500px"
      :close-on-click-modal="false"
    >
    <div class="padding20 flex align-center">
      <div class="right10">绑定的客服：</div>
      <el-select
    v-model="info.admin_list"
    filterable
    remote
    placeholder="请输入关键词"
    :remote-method="remoteMethod"
    clearable
    multiple
    value-key="admin_id"
   >
    <el-option
      v-for="item in options"
      :key="item.admin_id"
      :label="item.admin_name"
      :value="item">
    </el-option>
  </el-select>
    </div>
      
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogShow = false" size="medium">取 消</el-button>
        <el-button
          type="primary"
          @click="bindSeatAndAdmin"
          size="medium"
          
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import dayjs from 'dayjs'
export default {

  data() {
    return {
      currentPage: 1,
      pagesize: 10,
      totalNum: 0,
      loading: false,
      tableData: [],
      dialogShow:false,
      info:{}, //选中的信息
      options:[]
    
    };
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    }
  },
  created() {
    this.getList();
  },
  methods: {
  
    getList() {
      this.loading = true;
      let data = {
        page: this.currentPage,
        pageNumber: this.pagesize,
      };
      this.axios
        .post("platform/Customerservice/getSeatList", data)
        .then((res) => {
          if (res.code == 0) {
            let list = res.data.list
            list.forEach(ele=>{
              ele.update_time = dayjs.unix(ele.update_time).format('YYYY-MM-DD hh:mm')
            })
            this.tableData = list;
            this.totalNum = res.data.total;
          }
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    //每页数据的条数
    handleSizeChange(size) {
      this.pagesize = size;
      this.getList();
    },
    //当前第几页
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.getList();
    },
    showDialog(item){
      this.options = item.admin_list||[]
      this.info = {
        seat_id:item.id,
        seat_cno:item.cno,
        admin_list:item.admin_list||[]
      }
      this.dialogShow = true
     
    },
    remoteMethod(query) {
      if(!query) return
       let data = {
        admin_name:query
       }
       this.axios
        .post("platform/Customerservice/searchToGetAdminList", data).then(res=>{
          this.options = res.data.list
        })
      
    },
    bindSeatAndAdmin(){
      let data = {
        seat_id:this.info.seat_id,
        seat_cno:this.info.seat_cno,
        admin_id_list:""
      }
      if(this.info.admin_list.length>0){
        let arr = this.info.admin_list.map(ele=>{
          return ele.admin_id
        })
        data.admin_id_list = arr.toString()
      }
      this.axios
        .post("platform/Customerservice/bindSeatAndAdmin", data).then(res=>{
          this.$message.success('修改成功！')
          this.dialogShow = false
          this.getList()
        }).catch(err=>{
          this.getList()
        })
    }
  }
    
   
};
</script>

<style lang="scss" scoped >
.container {
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
  padding: 20px;
}

.search-box {
  display: flex;
  flex-wrap: wrap;
  .input_width {
    width: 180px;
  }
  .item {
    display: flex;
    align-items: center;
    margin-bottom: 16px;
    .item_title {
      display: inline-block;
      width: 80px;
      margin-right: 8px;
      text-align: right;
      box-sizing: border-box;
    }
  }
}
</style>
